export default "__VITE_ASSET__Boo4CPyS__"